import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Plus from "./Plus";

const Disclosure = ({ question, answer, number }) => {
  const [visible, setVisible] = useState(false);

  const handleDisplay = () => setVisible((prevState) => !prevState);
  return (
    <div className="max-w-[21rem] lg:max-w-[55rem] w-full">
      <div className="flex items-center lg:items-center justify-between pb-[1.4rem] border-b-[0.5px] border-kBlue pt-[3.8rem] w-full lg:w-[55rem]">
        <span className="flex items-start lg:items-center">
          <p className="text-kBlue text-sm mr-[0.6rem] font-bold lg:text-[2.5rem] lg:mr-4">{`Q${number}.`}</p>
          <p className="text-k2Black text-sm max-w-[15.25rem] lg:max-w-full lg:text-xl font-semibold">
            {question}
          </p>
        </span>
        <span class="self-start lg:self-center" onClick={handleDisplay}>
          <Plus />
        </span>
      </div>

      <motion.div
        transition={{
          type: "tween",
          ease: "easeInOut",
        }}
        animate={{ height: visible ? "auto" : 0 }}
        className={`overflow-y-hidden`}
      >
        <p
          className={`px-[2rem] py-[2rem] lg:py-[4rem] text-k2Black text-sm lg:text-xl leading-loose font-semibold`}
        >
          {answer}
        </p>
      </motion.div>
    </div>
  );
};

export default Disclosure;
